import type { AnswerGroupClassificationConfigurationDto, AnswerGroupConfigurationDto, AnswerGroupDto, AnswerGroupGridItemDto, AnswerGroupPagedRequestDto, CreateUpdateAnswerGroupInputDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class AnswerGroupService {
  apiName = 'Default';
  

  createAnswerGroupByInput = (input: CreateUpdateAnswerGroupInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/answer-group/answer-group',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  deleteAnswerGroupByAnswerGroupId = (answerGroupId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/answer-group/answer-group/${answerGroupId}`,
    },
    { apiName: this.apiName,...config });
  

  editAnswerGroupByInput = (input: CreateUpdateAnswerGroupInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/answer-group/edit-answer-group',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getAllAnswerGroupsByInput = (input: AnswerGroupPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<AnswerGroupGridItemDto>>({
      method: 'GET',
      url: '/api/app/answer-group/answer-groups',
      params: { filter: input.filter, state: input.state, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getAnswerGroupByAnswerGroupId = (answerGroupId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, AnswerGroupDto>({
      method: 'GET',
      url: `/api/app/answer-group/answer-group/${answerGroupId}`,
    },
    { apiName: this.apiName,...config });
  

  getAnswerGroupClassificationConfigurationDtoByAnswerGroupClassificationIdByAnswerGroupClassificationId = (answerGroupClassificationId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, AnswerGroupClassificationConfigurationDto>({
      method: 'GET',
      url: `/api/app/answer-group/answer-group-classification-configuration-dto-by-answer-group-classification-id/${answerGroupClassificationId}`,
    },
    { apiName: this.apiName,...config });
  

  getAnswerGroupClassificationsByAnswerGroupIdAndQuestionConfigurationItemId = (answerGroupId: number, questionConfigurationItemId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, AnswerGroupConfigurationDto>({
      method: 'GET',
      url: '/api/app/answer-group/answer-group-classifications',
      params: { answerGroupId, questionConfigurationItemId },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
